<div class="card card-s card-border-2 full-width">
  <div class="card-body">
    <div class="mb-24">
      <nz-skeleton-element
        nzType="input"
        nzSize="small"
        style="width: 20%"
        [nzActive]="true"
      ></nz-skeleton-element>
    </div>

    <div class="mb-24">
      <nz-skeleton-element
        nzType="input"
        nzSize="default"
        style="width: 70%"
        [nzActive]="true"
      ></nz-skeleton-element>
    </div>

    <div class="mt-24">
      <nz-skeleton-element
        nzType="input"
        nzSize="default"
        style="width: 100%"
        [nzActive]="true"
      ></nz-skeleton-element>
    </div>
  </div>
</div>
